import styled from 'styled-components';

import { breakPoints } from '~/src/constants/breakpoints';

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-template-areas: 'large first'
  'second third';
  row-gap: 24px;
  column-gap: 26px;
  width: 100%;

  @media (max-width: ${breakPoints.tablet}) {
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: 'large large large'
  'second first third';
  }

  @media (max-width: ${breakPoints.mobile}) {
    grid-template-rows: min-content min-content min-content min-content;
    grid-auto-rows: min-content;
    grid-template-columns: 100%;
    grid-template-areas: 
    'large' 
    'first' 
    'second' 
    'third';
  }
`;
